// extracted by mini-css-extract-plugin
export default {"page":"mugshot-page_page__XUMy6","image-container":"mugshot-page_image-container__2khcA","image":"mugshot-page_image__NYHCq","bottombar":"mugshot-page_bottombar__4A9Eg"};